var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/footer/navigation.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/navigation-items.j2", false, "core/templates/footer/navigation.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderNavItem")) {
var t_4 = t_1.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_4);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")) {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")),"mainNavigation")) {
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"footerNavigation")),"mainNavigation");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("column", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
var t_9;
t_9 = runtime.memberLookup((t_8),"slug");
frame.set("featureSlug", t_9, true);
if(frame.topLevel) {
context.setVariable("featureSlug", t_9);
}
if(frame.topLevel) {
context.addExport("featureSlug", t_9);
}
var t_10;
t_10 = Math.floor(12 / runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"length"));
frame.set("mainNavWidth", t_10, true);
if(frame.topLevel) {
context.setVariable("mainNavWidth", t_10);
}
if(frame.topLevel) {
context.addExport("mainNavWidth", t_10);
}
output += "<div class=\"o-column o-extra-small--12 o-medium--";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "mainNavWidth"), env.opts.autoescape);
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")?"u-no-gutters":""), env.opts.autoescape);
output += " c-footer-help__list--outer\">\n\n                <div class=\"c-footer-help u-global-margin\"  data-qa-footer-links=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"displayName"), env.opts.autoescape);
output += "\">\n\n                    <div ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
output += "class=\"o-accordion js-accordion\" role=\"tablist\" aria-multiselectable=\"true\"";
;
}
output += ">\n\n                        <div class=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")?"o-accordion__tabset js-accordion-tabset is-collapsed":""), env.opts.autoescape);
output += "\">\n\n                            ";
output += runtime.suppressValue((lineno = 15, colno = 69, runtime.callWrap(t_4, "renderNavItem", context, [t_8,runtime.makeKeywordArgs({"caller": (function (){var macro_t_11 = runtime.makeMacro(
["navItem", "url", "target"], 
[], 
function (l_navItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItem", l_navItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_12 = "";if(runtime.memberLookup((l_navItem),"typeCode") == "HEADING") {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
t_12 += "<a ";
t_12 += runtime.suppressValue((lineno = 20, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["footer",runtime.memberLookup((l_navItem),"slug")])), env.opts.autoescape);
t_12 += " href=\"#\" class=\"o-accordion__tab c-footer-help-accordion__tab js-accordion-tab\" aria-selected=\"true\" aria-expanded=\"true\" role=\"tab\" data-accordion-title=\"";
t_12 += runtime.suppressValue(runtime.memberLookup((l_navItem),"displayName"), env.opts.autoescape);
t_12 += "\" data-qa-footer-accordion>\n\n                                            <h3 class=\"c-footer-help__h3 c-footer-help__accordion--h2\">\n                                                ";
t_12 += runtime.suppressValue(runtime.memberLookup((l_navItem),"displayName"), env.opts.autoescape);
t_12 += "\n                                            </h3>\n\n                                        </a>";
;
}
else {
t_12 += "<h3 class=\"c-footer-help__h3\">\n                                            ";
t_12 += runtime.suppressValue(runtime.memberLookup((l_navItem),"displayName"), env.opts.autoescape);
t_12 += "\n                                        </h3>";
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_12);
});
return macro_t_11;})()})])), env.opts.autoescape);
output += "\n\n\n\n                            <div ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
output += "class=\"o-accordion__panel c-footer-help-accordion__panel js-accordion-panel\" role=\"tabpanel\"";
;
}
output += " aria-hidden=\"false\">";
if(runtime.memberLookup((t_8),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((t_8),"childSlugs")) > 0) {
output += "<ul class=\"c-footer-help__ul\">";
frame = frame.push();
var t_15 = runtime.memberLookup((t_8),"childSlugs");
if(t_15) {var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("childSlug", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += runtime.suppressValue((lineno = 48, colno = 85, runtime.callWrap(t_4, "renderNavItem", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_16),runtime.makeKeywordArgs({"caller": (function (){var macro_t_17 = runtime.makeMacro(
["navItem", "url", "target"], 
[], 
function (l_navItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItem", l_navItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_18 = "";t_18 += "\n\n                                                ";
var t_19;
t_19 = "noopener noreferrer";
frame.set("rel", t_19, true);
if(frame.topLevel) {
context.setVariable("rel", t_19);
}
if(frame.topLevel) {
context.addExport("rel", t_19);
}
t_18 += "\n\n                                                <li class=\"c-footer-help__li\">\n                                                    ";
if(runtime.memberLookup((l_navItem),"slug") == "help-orderstatus") {
t_18 += "<a ";
t_18 += runtime.suppressValue((lineno = 56, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["footer",runtime.memberLookup((l_navItem),"slug")])), env.opts.autoescape);
t_18 += " href=\"#\" class=\"c-footer-help__a c-footer-help__a--";
t_18 += runtime.suppressValue(t_16, env.opts.autoescape);
t_18 += " js-user-order-status\" data-qa-order-status-footer>";
t_18 += runtime.suppressValue(runtime.memberLookup((l_navItem),"displayName"), env.opts.autoescape);
t_18 += " </a>";
;
}
else {
if(runtime.memberLookup((l_navItem),"slug") == "footer-chat") {
t_18 += "<a href=\"";
t_18 += runtime.suppressValue((lineno = 60, colno = 70, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.thirdParty.default.salesforce.chat_widget.init_hash",""])), env.opts.autoescape);
t_18 += "\" class=\"c-footer-help__a c-footer-help__a--";
t_18 += runtime.suppressValue(t_16, env.opts.autoescape);
t_18 += "\" data-qa-footer-nav-links>\n                                                            ";
t_18 += runtime.suppressValue(runtime.memberLookup((l_navItem),"displayName"), env.opts.autoescape);
t_18 += "\n                                                        </a>";
;
}
else {
t_18 += "<a ";
t_18 += runtime.suppressValue((lineno = 66, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["footer",runtime.memberLookup((l_navItem),"slug")])), env.opts.autoescape);
t_18 += " ";
if(l_target) {
t_18 += " target=\"";
t_18 += runtime.suppressValue(l_target, env.opts.autoescape);
t_18 += "\" ";
if(l_target == "_blank") {
t_18 += " rel=\"";
t_18 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_18 += "\" ";
;
}
t_18 += " ";
;
}
t_18 += " href=\"";
t_18 += runtime.suppressValue(l_url, env.opts.autoescape);
t_18 += "\" class=\"c-footer-help__a c-footer-help__a--";
t_18 += runtime.suppressValue(t_16, env.opts.autoescape);
t_18 += "\" data-qa-footer-nav-links data-qa-footer-nav-slug=\"";
t_18 += runtime.suppressValue(runtime.memberLookup((l_navItem),"slug"), env.opts.autoescape);
t_18 += "\">";
t_18 += runtime.suppressValue(runtime.memberLookup((l_navItem),"displayName"), env.opts.autoescape);
t_18 += "</a>";
;
}
;
}
t_18 += "</li>\n\n                                            ";
;
frame = frame.pop();
return new runtime.SafeString(t_18);
});
return macro_t_17;})()})])), env.opts.autoescape);
;
}
}
frame = frame.pop();
output += "</ul>";
;
}
output += "</div>\n\n                        </div>\n\n                    </div>\n\n                </div>\n\n            </div>";
;
}
}
frame = frame.pop();
;
}
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/footer/navigation.j2"] , dependencies)